export default {
    ENV: 'prod',
    API_HOST: 'https://www.kangennuo.com/api',
    HOST: '',
    APP_ID: '',
    WX_APP_ID: 'wxd0ba71665d141047'
}
